/**
 * @fileOverview The main entry point to your standalone. Start editing here.
 */

import React, { useEffect, useState } from 'react'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/reset.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/site.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/segment.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/container.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/header.css'
// import '@ta-interaktiv/semantic-ui/semantic/dist/components/image.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/list.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/form.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/input.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/checkbox.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/divider.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/button.css'
import './styles.scss'
import { Masthead } from '@ta-interaktiv/react-masthead'
import { Footer } from '@ta-interaktiv/react-footer'
import { ThemeSwitch } from '@ta-interaktiv/react-theme-switch'
import { parseHostname } from '@ta-interaktiv/parse-hostname'
import AnimatedMap from '../animatedmap/component.js'
import Categories from '../categories'

const parsedHost = parseHostname()

const ARTICLE_ID = '573788141937' // ToDo

export function AppComponent() {
  const [map, setMap] = useState(null)
  const [selectedCategories, setSelectedCategories] = useState([])

  useEffect(() => {
    if (map) {
      if (selectedCategories.length === 0) {
        map.setFilter('data', undefined)
      } else {
        const filter = ['any']
        for (const i in selectedCategories) {
          filter.push(['==', 'category', selectedCategories[i]])
        }
        map.setFilter('data', filter)
      }
    }
  }, [selectedCategories])

  // Datawrapper auto height
  window.addEventListener('message', function(a) {
    if (undefined !== a.data['datawrapper-height'])
      for (const e in a.data['datawrapper-height']) {
        const t =
          document.getElementById('datawrapper-chart-' + e) ||
          document.querySelector("iframe[src*='" + e + "']")
        t && (t.style.height = a.data['datawrapper-height'][e] + 'px')
      }
  })

  return (
    <div className='index'>
      <Masthead articleId={ARTICLE_ID} enablePaywall={false} />
      <ThemeSwitch />

      <header className='ui vertical  very fitted  segment'>
        <div className='ui container'>
          <div className='ui header'>
            <h1>Hier finden Sie Geschenke in der Region Basel</h1>
            <h2>
              Mit diesen Geschenkideen können Sie Unternehmen aus der Region
              unterstützen. Aktivieren Sie die Karte, zoomen Sie rein und tippen
              Sie auf die Punkte.
            </h2>
          </div>
        </div>
      </header>

      <div className='ui container'>
        {/* <div className='ui text container formcontainer'> */}
        <div className='mapform'>
          <h2>Kategorie wählen</h2>
          <Categories
            selected={selectedCategories}
            onClick={c => {
              // Remove or add to Array
              if (c === 'all') {
                setSelectedCategories([])
              } else {
                if (selectedCategories.includes(c))
                  setSelectedCategories(selectedCategories.filter(f => f !== c))
                else setSelectedCategories([c].concat(selectedCategories))
              }
            }}
          />
          {/* </div> */}
        </div>
      </div>

      <div id='mapcontainer'>
        <AnimatedMap getMapObject={m => setMap(m)} />
      </div>
      <div className='ui vertical segment'>
        <div className='ui text container'>
          <div className='ta metainfo'>
            <div className='ta author'>
              <span>Katrin Hauser</span>
            </div>
          </div>
        </div>

        <div className='ui text container'>
          <div className='ta text'>
            <p>
              Weihnachten rückt immer näher, und damit wird auch das hartnäckige
              Pochen im Hinterkopf immer stärker, dass man sich um die Geschenke
              kümmern sollte. Ob der Vorstellung, sich in Einkaufszentren durch
              die Menschenmassen zu quetschen, wird manchen ganz Elend zumute.
            </p>

            <p>
              Es gibt jedoch eine andere, sehr viel gemütlichere Version des
              Weihnachtsbummels, bei der man erst noch lokale Unternehmen
              unterstützen kann: Die BaZ hat mithilfe des Interaktiv-Teams von
              Tamedia eine Shoppingkarte mit Unternehmen aus der Region
              zusammengestellt. Am 19. November haben wir Firmen aufgerufen,
              sich zu melden. Bis zum Einsendeschluss am 25. November haben sich
              über 190 Lädeler, Boutique-Besitzer und Freischaffende aus
              Basel-Stadt und dem Baselbiet gemeldet.
            </p>

            <p>
              Die Rückmeldungen waren rührend – die Not bei den Unternehmen aus
              der Region ist gross. «Ich erkenne mein Geschäft gar nicht mehr
              wieder», schrieb uns eine Inhaberin. So leer sei es in der
              Corona-Zeit geworden. Sie hoffe fest, dass mehr Menschen durch
              diese Karte auf ihr Geschäft aufmerksam werden.
            </p>

            <p>
              An die Corona-Problematik haben wir selbstverständlich auch
              gedacht. Gerade Angehörige der Risikogruppen, die sich vielleicht
              nicht trauen, durch die Läden zu streifen, haben die Möglichkeit,
              bei den Online-Shops zu bestellen. Diese sind in der
              untenstehenden Tabelle zu finden.
            </p>
          </div>
        </div>
      </div>

      <div className='ui container' style={{ paddingTop: '50px' }}>
        <div
          dangerouslySetInnerHTML={{
            __html: `<iframe title="Durchsuchen Sie die Angebote nach Ihrer Gemeinde oder Kategorie" aria-label="chart" id="datawrapper-chart-qg94i" src="https://datawrapper.dwcdn.net/qg94i/" scrolling="no" frameborder="0" style="width: 0; min-width: 100% !important; border: none;" height="7049"></iframe><script type="text/javascript">!function(){"use strict";window.addEventListener("message",(function(a){if(void 0!==a.data["datawrapper-height"])for(var e in a.data["datawrapper-height"]){var t=document.getElementById("datawrapper-chart-"+e)||document.querySelector("iframe[src*='"+e+"']");t&&(t.style.height=a.data["datawrapper-height"][e]+"px")}}))}();</script>`
          }}
        />
      </div>

      {/* <div className='ui vertical segment intro'>
        <div className='ui text container formcontainer'>
          <h2>Wie lege ich einen Eintrag an?</h2>
          <p>
            Sie können weiterhin Einträge erfassen. Sobald wir Ihre Daten
            geprüft haben, erscheinen sie auf dieser Karte.
          </p>
          <a
            href={`https://${parsedHost.projectDomain}/2020/basel-liefert-erfassen/`}
            className='ui primary button'
          >
            Eintrag erfassen
          </a>

          <h2>Wie kann ich mich austragen lassen?</h2>
          <p>
            Schreiben Sie uns eine E-Mail an{' '}
            <a
              href='mailto:sebastian.briellmann@baz.ch'
              target='_blank'
              rel='noopener noreferrer'
            >
              sebastian.briellmann@baz.ch
            </a>
            . Andernfalls werden Ihre Daten gelöscht, sobald diese Karte nicht
            mehr benötigt wird.
          </p>
        </div>
      </div> */}

      {/* TODO Add your credits in this component */}
      <Footer
        articleId={ARTICLE_ID}
        hidePortfolioTeaser
        hideUserFeedback
        credits={[
          ['Umsetzung', 'Mathias Born, Simon Huwiler, Svenson Cornehls']
        ]}
      />
    </div>
  )
}
